import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var InMemoryStore = /*#__PURE__*/_createClass(function InMemoryStore() {
  var _this = this;
  _classCallCheck(this, InMemoryStore);
  _defineProperty(this, "data", {});
  _defineProperty(this, "length", 0);
  _defineProperty(this, "setItem", function (key, value) {
    _this.data[key] = value;
    _this.length = Object.keys(_this.data).length;
    return value;
  });
  _defineProperty(this, "getItem", function (key) {
    if (key in _this.data) {
      return _this.data[key];
    }
    return null;
  });
  _defineProperty(this, "removeItem", function (key) {
    if (key in _this.data) {
      delete _this.data[key];
    }
    _this.length = Object.keys(_this.data).length;
    return null;
  });
  _defineProperty(this, "clear", function () {
    _this.data = {};
    _this.length = 0;
  });
  _defineProperty(this, "key", function (index) {
    return Object.keys(_this.data)[index];
  });
});

// eslint-disable-next-line import/no-anonymous-default-export
var inmemorystorage = new InMemoryStore();
export default inmemorystorage;